/**
 * Formats file size in bytes to a human-readable string
 * @param bytes - File size in bytes
 * @returns Formatted string (e.g., "2.5 MB", "128 KB")
 */
function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';

  const BYTES_PER_KB = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KB));

  return `${parseFloat((bytes / Math.pow(BYTES_PER_KB, i)).toFixed(2))} ${sizes[i]}`;
}

export { formatFileSize };
